import React, { MouseEvent } from 'react';

import DeleteIcon from '@mui/icons-material/HighlightOff';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

interface PickerResetButtonProps {
  disabled?: boolean;
  title?: string; //Tooltip title
  onReset: () => void;
}

function PickerResetButton(props: PickerResetButtonProps) {
  function handleClick(event: MouseEvent<HTMLButtonElement>) {
    event.preventDefault();
    props.onReset();
  }

  return (
    <Tooltip title={props.title || ''} placement="bottom-start">
      <IconButton
        size="small"
        color="default"
        disabled={props.disabled}
        onClick={handleClick}
      >
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
}

export default PickerResetButton;
